import { render, staticRenderFns } from "./receivable_details.vue?vue&type=template&id=76c4845c&scoped=true&"
import script from "./receivable_details.vue?vue&type=script&lang=js&"
export * from "./receivable_details.vue?vue&type=script&lang=js&"
import style0 from "./receivable_details.vue?vue&type=style&index=0&id=76c4845c&prod&lang=scss&scoped=true&"
import style1 from "./receivable_details.vue?vue&type=style&index=1&id=76c4845c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c4845c",
  null
  
)

export default component.exports